import type { ReactElement, ReactNode } from 'react'
import React, { forwardRef, memo } from 'react'

import type { FontSize, Variant, Width } from '../../../themes'
import Tooltip from '../Tooltip/Tooltip'
import { StyledChip } from './Chip.styles'

export interface ChipProps extends React.HTMLAttributes<HTMLDivElement> {
  'data-e2e'?: string
  bold?: boolean
  children?: ReactNode
  className?: string
  height?: Width
  off?: boolean
  tooltip?: string
  trigger?: 'hover' | 'click'
  size?: FontSize
  variant?: Variant
  withBorder?: boolean
}

const Chip = forwardRef<HTMLDivElement, ChipProps>(
  (
    {
      'data-e2e': datae2e,
      bold = false,
      children,
      className,
      height = '2rem',
      off = false,
      tooltip,
      trigger = 'hover',
      size = 'medium',
      variant = 'secondary',
      withBorder = false,
      ...props
    },
    ref
  ) => {
    if (off) return children as ReactElement

    if (tooltip)
      return (
        <Tooltip
          data-e2e={`${datae2e}--tooltip`}
          tooltip={tooltip}
          variant="black"
          placement="top"
          trigger={trigger}
        >
          <StyledChip
            bold={bold}
            className={className}
            data-e2e={datae2e}
            height={height}
            size={size}
            variant={variant}
            withBorder={withBorder}
            ref={ref}
            {...props}
          >
            {children}
          </StyledChip>
        </Tooltip>
      )

    return (
      <StyledChip
        bold={bold}
        className={className}
        data-e2e={datae2e}
        height={height}
        size={size}
        variant={variant}
        withBorder={withBorder}
        ref={ref}
        {...props}
      >
        {children}
      </StyledChip>
    )
  }
)

export default memo(Chip)
